module.exports = __webpack_public_path__ + "assets/img/no-energy.591415ed.png";